import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;

class TinyNodeSensorSettingsForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Upozornění" >
          {getFieldDecorator('reportsEnabled', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.reportsEnabled
              ? this.props.initialValues.reportsEnabled
              : null,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />} />
          )}
        </FormItem>
        {this.props.type && this.props.type !== 'modal'
          ? <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Uložit</Button>
          </FormItem>
          : null}
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          className={'cstm-modal-form'}
          width={700}
          title="Nastavení senzoru"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText="Uložit"
          onOk={this.handleSubmit} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(TinyNodeSensorSettingsForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/TinyNodeSensorSettingsForm.js